import { TealiumActionTypes } from './tealium.actionTypes';

export namespace TealiumAnalytics {
  export class EmailQuoteAction {
    static readonly type = TealiumActionTypes.EmailQuote;
  }

  export class InitTealiumAction {
    static readonly type = TealiumActionTypes.InitTealium;
  }
}
